import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.mypage');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-mypage',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.mypage/view.scss */
/* src/app/page.mypage/view.scss: no such file or directory */`],
})
export class PageMypageComponent implements OnInit {
    public user: any = {};

    public qrCodeImage: string | null = null;
    public otpPassword: string = '';
    public currentPassword: string = '';
    public errorMessages: any = {};
    public isVerified: boolean = false;
    public isOtpVerified: boolean = false;
    public activeTab: string = 'info';

    public tabs = [
        { key: 'info', label: '기본 정보' },
        { key: 'password', label: '비밀번호 변경' },
        { key: 'otp', label: 'OTP 초기화' }
    ];

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/login");
        await this.loadUserInfo();
    }

    public async verifyPassword() {
        if (!this.currentPassword) return await this.service.alert.warning("현재 비밀번호를 입력해주세요.");

        this.service.loading.show();
        const { code, message } = await wiz.call("verify_password", { password: this.currentPassword });
        this.service.loading.hide();

        if (code === 200) {
            this.isVerified = true;
            await this.service.alert.success("비밀번호 인증 성공");
        } else {
            this.isVerified = false;
            await this.service.alert.error("비밀번호 인증 실패");
        }
    }

    public async confirmPasswordReset() {
        const confirm = await this.service.alert.warning("비밀번호를 초기화하시겠습니까?");
        if (!confirm) return;

        this.service.loading.show();
        const { code, message } = await wiz.call("reset_password");
        this.service.loading.hide();

        if (code === 200) {
            await this.service.alert.success("비밀번호 초기화가 완료되었습니다.\n초기 비밀번호는 ID + 1234 입니다.\n재접속하여 비밀번호 재설정을 진행해주세요");
            this.isVerified = false;
            window.location.href = '/auth/logout';
        } else {
            await this.service.alert.error("비밀번호 초기화 실패");
        }
    }

    public async verifyOtpPassword() {
        if (!this.otpPassword) return await this.service.alert.warning("현재 비밀번호를 입력해주세요.");

        this.service.loading.show();
        const { code, message } = await wiz.call("verify_password", { password: this.otpPassword });
        this.service.loading.hide();

        if (code === 200) {
            this.isOtpVerified = true;
            await this.service.alert.success("비밀번호 인증 성공");
        } else {
            this.isOtpVerified = false;
            await this.service.alert.error("비밀번호 인증 실패");
        }
    }

    public async confirmOtpReissue() {
        const confirm = await this.service.alert.warning("OTP를 초기화하시겠습니까?");
        if (!confirm) return;
        if (!this.isOtpVerified) return;

        this.service.loading.show();
        const { code, data, message } = await wiz.call("reissue_otp");
        this.service.loading.hide();

        if (code === 200) {
            this.qrCodeImage = data.qr_code_image;
            await this.service.alert.success("OTP 초기화가 완료되었습니다.\n재접속하여 OTP 재발급을 진행해주세요");
            this.isOtpVerified = false;
            window.location.href = '/auth/logout';
        } else {
            await this.service.alert.error("OTP 재발급 실패");
        }
    }

    public async setTab(tab: string) {
        this.activeTab = tab;
        await this.service.render();
        
        if (tab === 'password') {
            // 비밀번호 초기화 탭 선택 시 초기화
            this.isVerified = false;
            this.currentPassword = '';
            this.errorMessages.currentPassword = null;
        } else if (tab === 'otp') {
            // OTP 초기화 탭 선택 시 초기화
            this.isOtpVerified = false;
            this.otpPassword = '';
            this.qrCodeImage = null;
            this.errorMessages.otpPassword = null;
        }
    }

    public async loadUserInfo() {
        await this.service.loading.show();
        let { code, data } = await wiz.call("get_user_info");
        if (code !== 200) return await this.service.alert.error("사용자 정보를 불러오는 데 실패했습니다.");
        this.user = data;
        await this.service.loading.hide();
        await this.service.render();
    }

    public async saveUserInfo() {
        this.service.loading.show();
        let { code } = await wiz.call("update_user_info", this.user);
        this.service.loading.hide();

        if (code === 200) {
            await this.service.alert.success("기본 정보가 성공적으로 업데이트되었습니다.");
        } else {
            await this.service.alert.error("기본 정보 업데이트에 실패했습니다.");
        }
    }

    public getLabel(key: string) {
        return this.tabs.find(t => t.key === key)?.label ?? '';
    }
}

export default PageMypageComponent;